import { PageViewEventLogger } from '@repo/tracking-service';
import Head from 'next/head';

import CustomerReviews from '@/components/landing/CustomerReviews';
import ReviewTextCardGrid from '@/components/landing/ReviewTextCardGrid';
import ReviewsMain from '@/components/landing/ReviewsMain';
import VideoModal, { useVideoModal } from '@/components/landing/VideoModal';
import HomeLayout from '@/components/layout/HomeLayout';
import { emptyStaticProps } from '@/lib/web/common-ssr';

const Reviews = () => {
  const { videoURL, openVideoPopup, closeVideoPopup } = useVideoModal();

  return (
    <PageViewEventLogger pageName={'landing'} eventName={'landing_review'}>
      <HomeLayout>
        <ReviewsMain openVideoPopup={openVideoPopup} />
        <CustomerReviews openVideoPopup={openVideoPopup} />
        <ReviewTextCardGrid />
        {videoURL && <VideoModal videoURL={videoURL} closePopup={closeVideoPopup} />}
      </HomeLayout>
    </PageViewEventLogger>
  );
};

Reviews.getLayout = (page: any) => (
  <>
    <Head>
      <title>비즈넵 환급 - 사업자 정부 환급금, 지금 무료로 확인하세요</title>
    </Head>
    {page}
  </>
);

export const getStaticProps = emptyStaticProps;

export default Reviews;
